import React, { useContext } from "react";
import styled from "styled-components";

import { FormContext } from "../../contexts/FormContext";
import { inputGlow } from "../../utils/styles";

import TextInput from "./TextInput";

const Styled = styled.div<{ width?: string }>`
  background-color: #fff;
  border: solid 1px #ccc;
  border-radius: 0.3rem;
  display: flex;
  gap: 0.3rem;
  align-items: center;
  height: 3rem;
  box-sizing: border-box;
  padding: 0 0.5rem;
  width: ${({ width }) => width || "100%"};

  // override the focus indicator to be on the div
  ${inputGlow}
  input {
    border: none;
    background-color: transparent;
    width: 100%;
    font-family: inherit;
    outline: transparent;
  }
`;

const Icon = styled.div`
  margin-right: 0.3rem;

  svg {
    display: block;
    fill: #999;
  }
`;

interface Props
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "onChange" | "color"
  > {
  inputRef?: React.RefObject<HTMLInputElement>;
  onChange?: (value: string) => void;
  onEnterKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

/**
 * we pull out a few properties (like width) to ensure the element
 * behaves like you'd expect despite the weird 'actually-a-div' thing
 * @todo this is not fully implemented yet
 */
const SearchField = ({ width, ...props }: Props) => {
  const form = useContext(FormContext);

  return (
    <Styled width={"" + width}>
      <Icon>
        <svg height="16" viewBox="0 0 515.558 515.558">
          <path d="m378.344 332.78c25.37-34.645 40.545-77.2 40.545-123.333 0-115.484-93.961-209.445-209.445-209.445s-209.444 93.961-209.444 209.445 93.961 209.445 209.445 209.445c46.133 0 88.692-15.177 123.337-40.547l137.212 137.212 45.564-45.564c0-.001-137.214-137.213-137.214-137.213zm-168.899 21.667c-79.958 0-145-65.042-145-145s65.042-145 145-145 145 65.042 145 145-65.043 145-145 145z" />
        </svg>
      </Icon>
      <TextInput
        ref={props.inputRef}
        type="text"
        {...props}
        variant="plain"
        spellCheck={false}
        autoCapitalize="off"
        placeholder={props.placeholder || "Search..."}
        disabled={props.disabled ?? form.disabled}
        onChange={(e) => {
          props.onChange?.(e.target.value);
        }}
      />
    </Styled>
  );
};

export default SearchField;
